import Vue from 'vue'
import App from './PlayMobile.js'

Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

new Vue(App)
